import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import React from 'react';
import Page from './components/Page';
import Simple from './Pages/Configurator/Table/Simple';
import LandingPage from './Pages/Landing';
import CatalougePage from './Pages/Configurator';
import NotFound from './Pages/NotFound';
import ContactUs from './Pages/ContactUs';
import Basket from './Pages/Basket';
import QuoteSent from './Pages/QuoteSent';
import Certificates from './Pages/Certificates';
import Distributors from './Pages/Distributors';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import CookiePolicy from './Pages/CookiePolicy';
import Blog from './Pages/Blog';
import BlogPost from './Pages/Blog/BlogPost';
import MainPage from './Pages/Main';
import SearchResults from './Pages/SearchResults';
import RouteError from './components/RouteError';

const router = createBrowserRouter([
  {
    path: '/',
    element: <MainPage />,
    errorElement: <RouteError />,
  },
  {
    path: '/landing',
    element: <LandingPage />,
    errorElement: <RouteError />,
  },
  {
    path: '/contact',
    element: <ContactUs />,
    errorElement: <RouteError />,
  },
  {
    path: '/products/:id',
    element: <CatalougePage />,
    errorElement: <RouteError />,
  },
  {
    path: '/products',
    element: <CatalougePage />,
    errorElement: <RouteError />,
  },
  {
    path: '/products/:name/list/:itemcode',
    element: <Simple />,
    errorElement: <RouteError />,
  },
  {
    path: '/products/:name/list',
    element: <Simple />,
    errorElement: <RouteError />,
  },
  {
    path: '/search',
    element: <SearchResults />,
    errorElement: <RouteError />,
  },
  {
    path: '/basket',
    element: <Basket />,
    errorElement: <RouteError />,
  },
  {
    path: '/quote-success',
    element: <QuoteSent />,
    errorElement: <RouteError />,
  },
  {
    path: '/certificates',
    element: <Certificates />,
    errorElement: <RouteError />,
  },
  {
    path: '/distributors',
    element: <Distributors />,
    errorElement: <RouteError />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
    errorElement: <RouteError />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicy />,
    errorElement: <RouteError />,
  },
  {
    path: '/blog',
    element: <Blog />,
    errorElement: <RouteError />,
  },
  {
    path: '/blog/:id',
    element: <BlogPost />,
    errorElement: <RouteError />,
  },
  {
    path: '*',
    element: <NotFound />,
    errorElement: <RouteError />,
  },
]);

function App() {
  return (
    <Page>
      <RouterProvider router={router} />
    </Page>
  );
}

export default App;
